import { Typography, Box, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { ReferenceField, TextField, useRecordContext } from "react-admin";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { administrationRequests } from "api/administrationApi";

const RankingAccordionItem = () => {
  const record = useRecordContext();

  const priorityBySpecialityId = (record.specialities ?? []).reduce((acc, spec) => {
    acc[spec.specialityId] = spec.priority;
    return acc;
  }, {});

  const groupedRankings = record.rankingResults.reduce((acc, ranking) => {
    const key = ranking.rankingNumber;
    if (!acc[key]) {
      acc[key] = {
        rankingNumber: ranking.rankingNumber,
        rankingNumberText: ranking.rankingNumberText,
        specialities: [],
      };
    }
    acc[key].specialities.push(ranking);
    return acc;
  }, {});

  const rankingsArray = Object.values(groupedRankings).sort((a, b) => a.rankingNumber - b.rankingNumber);
  rankingsArray.forEach(ranking =>
    ranking.specialities.sort(
      (a, b) => (priorityBySpecialityId[a.specialityId] ?? 0) - (priorityBySpecialityId[b.specialityId] ?? 0),
    ),
  );
  // rankingsArray is sorted ascending by rankingNumber, so the last item is the latest ranking.
  const latestRankingIndex = rankingsArray.length - 1;
  const [expanded, setExpanded] = useState(latestRankingIndex);

  const handleChange = index => (event, isExpanded) => {
    setExpanded(isExpanded ? index : false);
  };

  return (
    <Box>
      {rankingsArray.length < 1 && <div style={{ padding: "16px", fontSize: "14px" }}>Няма намерени резултати</div>}
      {rankingsArray.map((ranking, index) => (
        <Accordion
          key={ranking.rankingNumber}
          expanded={expanded === index}
          onChange={handleChange(index)}
          sx={{ mb: 1, display: "flex", flexDirection: "column", width: "100%" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ width: "100%" }}
          >
            <Box>
              <Typography fontWeight={600}>{ranking.rankingNumberText} класиране</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {ranking.specialities.map((spec, specIndex) => (
                <Box
                  key={spec.campaignRankingId}
                  sx={{
                    pb: specIndex < ranking.specialities.length - 1 ? 2 : 0,
                    borderBottom: specIndex < ranking.specialities.length - 1 ? "1px solid #e0e0e0" : "none",
                  }}
                >
                  <Box>
                    <Typography
                      variant="span"
                      color={"primary"}
                    >
                      Желание:{" "}
                    </Typography>
                    <span>{priorityBySpecialityId[spec.specialityId] ?? specIndex + 1}</span>
                  </Box>
                  <Box>
                    <Typography
                      variant="span"
                      color={"primary"}
                    >
                      Специалност:{" "}
                    </Typography>
                    <ReferenceField
                      label="Специалност"
                      source="specialityId"
                      reference={administrationRequests.getSpecialitiesSelect()}
                      record={spec}
                      link={false}
                    >
                      <TextField source="name" />
                    </ReferenceField>
                  </Box>

                  <Box>
                    <Typography
                      variant="span"
                      color={"primary"}
                    >
                      Статус:{" "}
                    </Typography>
                    <TextField
                      source="statusText"
                      record={spec}
                    />
                  </Box>

                  <Box>
                    <Typography
                      variant="span"
                      color={"primary"}
                    >
                      Резултат:{" "}
                    </Typography>
                    <Typography component="span">{spec.scoreFormatted}</Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};
export default RankingAccordionItem;
